export const COLORS = {
  brand900: '#0e131f',
  brand700: '#333d4f',
  brand500: '#666e80',
  brand300: '#adafb2',
  brand200: '#eaeaea',
  brand100: '#f1f5f9',
  blue: '#1e3a5f',
  green: '#1f7a5c',
  orange: '#c7411c',
  amber: '#a65510',
  purple: '#7c3aed',
  white: '#ffffff'
};

export const DIAGRAMS = {
  workflow: {
    label: 'Grounded execution lifecycle',
    nodes: [
      { id: 'capture', label: 'Capture', phase: 'Intake', description: 'Bring client work into Flopinio from requests, inboxes, extensions, and connected channels.', x: 120, y: 150, color: COLORS.blue },
      { id: 'review', label: 'Review', phase: 'Triage', description: 'Turn raw intake into structured work with ownership, context, and next actions.', x: 315, y: 95, color: COLORS.brand900 },
      { id: 'execute', label: 'Execute', phase: 'Work', description: 'Move approved work through tasks, notes, decisions, and grounded runtime assistance.', x: 510, y: 150, color: COLORS.green },
      { id: 'bill', label: 'Bill', phase: 'Revenue', description: 'Keep time, invoice preparation, and billing context connected to delivered work.', x: 705, y: 95, color: COLORS.orange },
      { id: 'follow', label: 'Follow up', phase: 'Loop', description: 'Close the loop with client follow-through, open risks, and reusable operating context.', x: 900, y: 150, color: COLORS.purple }
    ],
    connections: [
      ['capture', 'review'],
      ['review', 'execute'],
      ['execute', 'bill'],
      ['bill', 'follow'],
      ['follow', 'capture', true]
    ]
  },
  knowledge_map: {
    label: 'Grounded knowledge hub',
    nodes: [
      { id: 'docs', label: 'Docs', phase: 'Hub', description: 'Public guides explain the product surfaces and how work moves through the system.', x: 500, y: 135, color: COLORS.brand900 },
      { id: 'extension', label: 'Browser Extension', phase: 'Capture', description: 'Planned: capture browser context into Flopinio with its source trail. Not yet publicly available.', x: 170, y: 75, color: COLORS.blue },
      { id: 'telegram', label: 'Telegram Bot', phase: 'Inbox', description: 'Route Telegram messages into structured intake and workspace follow-up.', x: 255, y: 220, color: COLORS.green },
      { id: 'runtime', label: 'Grounded Execution', phase: 'AI', description: 'AI assistance stays tied to real workspace records, approvals, and visible runtime steps.', x: 745, y: 220, color: COLORS.orange },
      { id: 'mcp', label: 'MCP Connector', phase: 'Tools', description: 'MCP access exposes scoped, approval-aware tools for connected client-work operations.', x: 830, y: 75, color: COLORS.purple }
    ],
    connections: [
      ['docs', 'extension'],
      ['docs', 'telegram'],
      ['docs', 'runtime'],
      ['docs', 'mcp']
    ]
  },
  security: {
    label: 'Shipped security layers',
    nodes: [
      { id: 'identity', label: 'Identity', phase: 'Access', description: 'Authentication, MFA-sensitive flows, recent-auth checks, and secure session handling protect access.', x: 160, y: 150, color: COLORS.blue },
      { id: 'scope', label: 'Resource Scope', phase: 'Tenancy', description: 'Organization scoping and default-deny authorization keep workspace records separated.', x: 360, y: 95, color: COLORS.brand900 },
      { id: 'approval', label: 'Approvals', phase: 'AI and MCP', description: 'MCP writes use manual review by default. Explicitly permitted tokens may self-approve their own eligible writes; both paths keep approval history.', x: 560, y: 150, color: COLORS.green },
      { id: 'audit', label: 'Audit Trail', phase: 'Visibility', description: 'Security and runtime events are logged so important changes remain inspectable.', x: 760, y: 95, color: COLORS.orange },
      { id: 'billing', label: 'Billing Integrity', phase: 'Payments', description: 'When production billing is configured, Paddle is designed to handle raw card processing while Flopinio verifies billing events and stores billing state.', x: 900, y: 180, color: COLORS.purple }
    ],
    connections: [
      ['identity', 'scope'],
      ['scope', 'approval'],
      ['approval', 'audit'],
      ['audit', 'billing']
    ]
  },
  roadmap: {
    label: 'Development trajectory',
    nodes: [
      { id: 'now', label: 'Shipped', phase: 'Now', description: 'Current public surfaces cover intake, execution, billing context, runtime visibility, and trust basics.', x: 150, y: 165, color: COLORS.green },
      { id: 'next', label: 'Active Themes', phase: 'Next', description: 'Near-term work deepens workflow clarity, onboarding, connected context, and operating visibility.', x: 390, y: 95, color: COLORS.blue },
      { id: 'later', label: 'Enterprise Controls', phase: 'Later', description: 'Future enterprise work expands governance, policy controls, audit depth, and team administration.', x: 630, y: 165, color: COLORS.orange },
      { id: 'future', label: 'Ecosystem', phase: 'Future', description: 'Longer-term direction connects more tools and partner workflows around the same execution model.', x: 870, y: 95, color: COLORS.purple }
    ],
    connections: [
      ['now', 'next'],
      ['next', 'later'],
      ['later', 'future']
    ]
  }
};

export const DESIGN = { width: 1000, height: 300 };
export const MOBILE_BREAKPOINT = 640;
export const MAX_DIMENSION_ATTEMPTS = 12;
